import axios from 'axios';

const instance = axios.create();
instance.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('accessToken')}`;
export default instance;

export const vanillaInstance = axios.create();